// @flow
import React from 'react'

import type { SelectItem } from '../../../SelectEnumRefIndex'

type OptionProps = {
  index: number,
  option: SelectItem
}

const Option = ({ index, option }: OptionProps) => {
  return (
    <option key={index} value={option.value}>{option.label}</option>
  )
}

export default Option
